import { render, staticRenderFns } from "./EditAppointment.vue?vue&type=template&id=4aa2aef2&scoped=true&"
import script from "./EditAppointment.vue?vue&type=script&lang=js&"
export * from "./EditAppointment.vue?vue&type=script&lang=js&"
import style0 from "./EditAppointment.vue?vue&type=style&index=0&id=4aa2aef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa2aef2",
  null
  
)

export default component.exports